import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpFileService } from '../../../../../service/http-file.service';
import { Subscription } from 'rxjs';
import { PreviewModalComponent } from '../../../../preview-modal/preview-modal.component';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-dynamic-form-input-file',
	standalone: false,
	templateUrl: './dynamic-form-input-file.component.html',
	styleUrl: './dynamic-form-input-file.component.scss'
})
export class DynamicFormInputFileComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;

	fileList: NzUploadFile[] = [];

	constructor(
		private fileService: HttpFileService,
		private modal: NzModalService) { }

	// Custom upload handler
	customUpload = (item: NzUploadXHRArgs): Subscription => {
		const formData = new FormData();
		formData.append('file', item.file as any);

		// Create the subscription
		const sub = this.fileService.upload(this.wrapper.element.property, formData).subscribe({
			next: (res) => {
				// success callback
				item.onSuccess!(res, item.file, event);
				console.log("Upload result: " + res.uuid);
				this.wrapper.control.setValue(res.uuid); this.wrapper.control.markAsDirty();
				this.wrapper.control.markAsTouched();
				this.wrapper.control.updateValueAndValidity();
			},
			error: (err) => {
				item.onError!(err, item.file);
			}
		});

		// return it so nz-upload can cancel if needed
		return sub;
	};

	// When removing the file
	onRemove(): boolean {
		this.form.get(this.toControlKey(this.wrapper.element))?.setValue(null);
		this.fileList = [];
		return true;
	}

		doPreviewFile() {
			const modal = this.modal.create({
				nzTitle: 'Preview',
				nzContent: PreviewModalComponent,
				nzWidth: '75%',
				nzBodyStyle: { height: '80vh', overflow: 'auto' },
				nzFooter: null
			});

			modal.componentInstance!.file = this.wrapper.control.value;
		}
		doDownloadFile() {
			this.fileService.downloadFile(this.wrapper.control.value).subscribe();
		}
}
